export const HeaderData = [
  {
    id: 1,
    label: 'Production Planning',
    route: '/production-planning',
  },
];
